import ZOOM_PLUS from "assets/icons/zoom_plus.svg";
import ZOOM_MINUS from "assets/icons/zoom_minus.svg";
import HOME from "assets/icons/home.svg";
import MapButton from "components/atoms/buttons/map/MapButton";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { MdCenterFocusStrong } from "react-icons/md";
import { AiOutlineZoomIn, AiOutlineZoomOut } from "react-icons/ai";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import DEFAULT_MAP from "assets/icons/map/map_type_default.png";
import SATELLITE_MAP from "assets/icons/map/map_type_satellite.png";
import { useAppSelector } from "redux/hooks";
import ClusterControl from "./ClusterControl";

type Props = {
  isRoadView: boolean;
  onZoomPlus: () => void;
  onZoomOut: () => void;
  onZoomFit: () => void;
  onChangeView: () => void;
  onChangeClusterRadius: (value: number) => void;
  clusterRadius: number;
  mapZoom: number | undefined;
};
const MapControl = (props: Props): JSX.Element => {
  const theme = useAppSelector((state) => state.theme.theme);
  const themeColor = theme === "light" ? COLORS.BLACK : COLORS.WHITE;

  const controls = [
    {
      type: "roadView",
      src: props.isRoadView ? SATELLITE_MAP : DEFAULT_MAP,
      image: true,
      onClick: () => props.onChangeView(),
    },
    {
      type: "home",
      src: HOME,
      icon: <MdCenterFocusStrong color={themeColor} size={24} />,
      onClick: () => props.onZoomFit(),
    },
    {
      type: "zoomPlus",
      src: ZOOM_PLUS,
      icon: <AiOutlineZoomIn color={themeColor} size={24} />,
      onClick: () => props.onZoomPlus(),
    },
    {
      type: "zoomMinus",
      src: ZOOM_MINUS,
      icon: <AiOutlineZoomOut color={themeColor} size={24} />,
      onClick: () => props.onZoomOut(),
    },
  ];

  return (
    <Control>
      {!mediaQuery.useIsMobile() && props.mapZoom && props.mapZoom < 17 && (
        <ClusterControl
          onChangeComplete={props.onChangeClusterRadius}
          defaultValue={props.clusterRadius}
        />
      )}

      <ControlContainer>
        {controls.map((item, index) => (
          <MapButton button={item} key={index} />
        ))}
      </ControlContainer>
    </Control>
  );
};

const Control = styled.div`
  ${FLEX.FlexCenterCenter};
  height: max-content;
  ${mediaQuery.isMobile} {
    flex-direction: row-reverse;
    align-items: flex-end;
  }
`;

const ControlContainer = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 5px;
  ${mediaQuery.isDefault} {
    flex-direction: column;
  }
  ${mediaQuery.isMobile} {
    gap: 4px;
    flex-direction: row-reverse;
  }
`;

export default MapControl;
